const theme = {
  title: {
    textStyle: {
      fontWeight: 'bold',
      color: '#333',
    },
  },

  visualMap: {
    color: [
      '#085982',
      '#115e85',
      '#256a8d',
      '#377493',
      '#4b809b',
      '#608ca2',
      '#7397a9',
      '#87a3b1',
      '#adb9bf',
      '#cccccc',
      '#d1c1c0',
      '#d0b6b4',
      '#cfa7a4',
      '#cc9490',
      '#c87d78',
      '#c4635d',
      '#bf463e',
      '#BB372E',
    ],
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: '#0080BA',
      },
    },
  },

  tooltip: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    textStyle: {
      color: '#000',
    },
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: '#27727B',
        type: 'dashed',
      },
      crossStyle: {
        color: '#27727B',
      },
      shadowStyle: {
        color: 'rgba(200,200,200,0.3)',
      },
    },
  },

  dataZoom: {
    dataBackgroundColor: 'rgba(0, 0, 0, 0)',
    fillerColor: 'rgba(167,183,204,0.4)',
    handleColor: '#A7B7CC',
  },

  categoryAxis: {
    axisLine: {
      lineStyle: {
        color: '#666',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#D0D0D0'],
        type: 'dotted',
      },
    },
    axisLabel: {
      color: '#333',
    },
    nameTextStyle: {
      color: '#333',
    },
  },

  valueAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#666',
      },
    },
    splitArea: {
      show: false,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#D0D0D0'],
        type: 'dotted',
      },
    },
    axisLabel: {
      color: '#333',
    },
    nameTextStyle: {
      color: '#333',
    },
  },

  timeline: {
    lineStyle: {
      color: '#666',
    },
    controlStyle: {
      normal: {
        color: '#27727B',
        borderColor: '#27727B',
      },
    },
    symbol: 'emptyCircle',
    symbolSize: 3,
    axisLabel: {
      color: '#333',
    },
    nameTextStyle: {
      color: '#333',
    },
  },

  line: {
    itemStyle: {
      normal: {
        borderWidth: 2,
        borderColor: '#fff',
        lineStyle: {
          width: 3,
        },
      },
      emphasis: {
        borderWidth: 0,
      },
    },
    symbol: 'circle',
    symbolSize: 3.5,
    markLine: {
      lineStyle: {
        color: '#666666',
      },
    },
  },

  candlestick: {
    itemStyle: {
      normal: {
        color: '#BB372E',
        color0: '#085982',
        lineStyle: {
          width: 1,
          color: '#BB372E',
          color0: '#085982',
        },
      },
    },
  },

  map: {
    label: {
      normal: {
        textStyle: {
          color: '#BB372E',
        },
      },
      emphasis: {
        textStyle: {
          color: 'rgb(100,0,0)',
        },
      },
    },
    itemStyle: {
      normal: {
        areaColor: '#ddd',
        borderColor: '#eee',
      },
      emphasis: {
        areaColor: '#fe994e',
      },
    },
  },

  gauge: {
    axisLine: {
      lineStyle: {
        color: [
          [0.2, '#085982'],
          [0.8, '#BBBBBB'],
          [1, '#BB372E'],
        ],
      },
    },
    axisTick: {
      splitNumber: 2,
      length: 5,
      lineStyle: {
        color: '#fff',
      },
    },
    axisLabel: {
      textStyle: {
        color: '#fff',
      },
    },
    splitLine: {
      length: '5%',
      lineStyle: {
        color: '#fff',
      },
    },
    title: {
      offsetCenter: [0, -20],
    },
  },
};

theme.visualMap.color.reverse();

export default (colorPalette) => ({
  ...theme,
  graph: {
    color: colorPalette,
  },
  color: colorPalette,
});
